import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["hits"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import createInfiniteQueryHook from '@segment/utils/createInfinityQueryHook';
import { useCatalogIndex } from '@segment/contexts/catalogIndex';
import { groupIntegrations } from './utils';
import { fetchIntegrations } from './common';
export var createGroupedIntegrationsQuery = function createGroupedIntegrationsQuery(catalogIndex) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$destination = _ref.destination,
      destination = _ref$destination === void 0 ? true : _ref$destination,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? true : _ref$source;

  return [["catalog", "groupedIntegrationsQuery", destination, source], /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var pageParam, _yield$fetchIntegrati, hits, rest, groups;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pageParam = _ref2.pageParam;
              _context.next = 3;
              return fetchIntegrations({
                catalogIndex: catalogIndex,
                query: "",
                category: null,
                destination: destination,
                pageParam: pageParam,
                source: source,
                distinct: 8,
                hitsPerPage: 4
              });

            case 3:
              _yield$fetchIntegrati = _context.sent;
              hits = _yield$fetchIntegrati.hits;
              rest = _objectWithoutProperties(_yield$fetchIntegrati, _excluded);
              groups = hits.reduce(groupIntegrations, []);
              return _context.abrupt("return", _objectSpread({
                hits: groups
              }, rest));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()];
};
export var useGroupedIntegrationsQuery = createInfiniteQueryHook(createGroupedIntegrationsQuery, useCatalogIndex, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    var _p$page;

    var page = (_p$page = p.page) !== null && _p$page !== void 0 ? _p$page : 0;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(p) {
    var _p$page2;

    var page = (_p$page2 = p.page) !== null && _p$page2 !== void 0 ? _p$page2 : 0;
    var nextPage = page + 1;

    if (nextPage >= p.nbPages) {
      return;
    }

    return nextPage;
  }
});